module.exports = __webpack_public_path__ + "img/img3.c9d5f51b.jpg";